{
  "customFormsFeaturesData": {
    "titles": {
      "checkOut": "체크아웃",
      "checkInDeprecated": "체크인(지원 중단)",
      "checkIn": "체크인",
      "receivedLoadInspection": "입고 화물 검사",
      "shippedLoadVerification": "출고 화물 확인",
      "appointmentsPerLoadType": "화물 유형별 예약",
      "assetDetails": "자산 세부 정보",
      "yardManagementSystem": "야드 관리 시스템",
      "smartGateIntegration": "SmartGate 연동",
      "gateManagement": "게이트 관리",
      "idValidation": "신원 확인",
      "appointmentCompleted": "예약 완료"
    },
    "subtitles": {
      "phoneNumberAndCarrierCompanyWillBeCollectedByDefault": "<strong>전화번호</strong>와 <strong>운송 회사</strong>는 기본적으로 수집됩니다"
    },
    "descriptions": {
      "captureCheckInDetailsFromDriversForBothPlannedAndUnplannedArrivals": "예정된 도착과 예정되지 않은 도착 모두에 대해 운전자의 체크인 세부 정보를 수집합니다.",
      "captureCheckOutDataAfterAnAppointmentIsCompleted": "예약이 완료된 후 체크아웃 데이터를 수집합니다.",
      "collectDriverInfoAsTheySelfCheckInForTheirPlannedAppointmentThisFeatureIsAnOptionalAddOnToOurGateManagementSolution": "운전자가 예정된 예약에 셀프 체크인할 때 운전자 정보를 수집합니다. 이 기능은 게이트 관리 솔루션의 선택적 추가 기능입니다.",
      "documentDamageDiscrepanciesOrOtherIssuesRelatedToTheReceivedLoad": "입고된 화물과 관련된 손상, 불일치 또는 기타 문제를 기록합니다.",
      "documentLoadIntegrityAndOtherSecurityMeasuresRelatedToTheShippedLoad": "출고된 화물과 관련된 화물 무결성 및 기타 보안 조치를 기록합니다.",
      "captureLoadTypeSpecificDetailsDuringAppointmentScheduling": "예약 시 화물 유형별 세부 정보를 수집합니다.",
      "storeAndTrackDetailsOfTrailersAndContainersAsTheyArriveAtYourYard": "야드에 도착하는 트레일러와 컨테이너의 세부 정보를 저장하고 추적합니다.",
      "enableTheYmsModuleForThisWarehouseAlsoEnableTheAssetVisitFieldsForTheGateManagementApp": "이 창고에 YMS 모듈을 사용 설정하고, 게이트 관리 앱의 자산 방문 필드도 사용 설정합니다.",
      "enableTheSmartGateModuleForThisWarehouse": "이 창고에 SmartGate 모듈을 사용 설정합니다.",
      "enableTheIdValidationForThisWarehouse": "이 창고에 신원 확인 모듈을 사용 설정합니다.",
      "enableTheGateManagementModuleForThisWarehouseWhichIncludesTheCheckIn": "체크인을 포함한 게이트 관리 모듈을 이 창고에 사용 설정합니다",
      "reviewAndManageAppointmentDataAfterCompletion": "완료 후 예약 데이터를 검토하고 관리합니다."
    },
    "helpLinks": {
      "learnHowItWorksOrContactUsToRequestATrial": "<a href=\"https://community.loadsmart.com/hc/en-us/articles/19326940613011-Carrier-Self-Check-In\" target=\"_blank\">작동 방식 알아보기</a> 또는 문의하여 <a href=\"https://lp.opendock.com/gate-management\" target=\"_blank\">체험판을 요청하세요.</a>.",
      "learnHowItWorks": "<a href=\"https://community.loadsmart.com/hc/en-us/articles/19326940613011-Carrier-Self-Check-In\" target=\"_blank\">작동 방식 알아보기.</a>"
    },
    "enableDisclaimers": {
      "theDriversWillSeeThisFormWhenTheyAreCheckingThemselvesIn": "운전자가 셀프 체크인할 때 이 양식이 표시됩니다.",
      "allFieldsOnThisFormWillBeAvailableAndVisibleDuringAppointmentScheduling": "이 양식의 모든 필드는 예약 시 <strong>사용 가능하며 표시됩니다</strong>."
    },
    "disableDisclaimers": {
      "theDriversWillNotSeeThisFormWhenTheyAreCheckingThemselvesIn": "운전자가 셀프 체크인할 때 이 양식이 표시되지 않습니다.",
      "allFieldsOnThisFormWillBeUnavailableDuringAppointmentSchedulingYouCanReEnableThisFormAtAnyTime": "이 양식의 모든 필드는 예약 시 <strong>사용할 수 없습니다</strong>.<br />언제든지 이 양식을 다시 사용 설정할 수 있습니다."
    },
    "labels": {
      "updateClaimsSupport": "클레임 지원 업데이트",
      "selectAClaimsSupportToUpdate": "업데이트할 클레임 지원 선택",
      "damageType": "손상 유형",
      "damageDescription": "손상 설명",
      "damagePhotos": "손상 사진",
      "discrepancyType": "불일치 유형",
      "discrepancyDescription": "불일치 설명",
      "discrepancyPhotos": "불일치 사진",
      "loadSecurityChecked": "화물 보안 확인됨",
      "loadSecurityDescription": "화물 보안 설명",
      "loadIntegrityPhotos": "화물 무결성 사진",
      "sealIntegrityPhotos": "봉인 무결성 사진"
    }
  }
}
